export const MAX_TABLET_WIDTH = 1019;
export const MAX_MOBILE_WIDTH = 759;
export const CATFISH_MOBILE_WIDTH = 550;

export const isMobile = () => {
    return window.innerWidth <= MAX_MOBILE_WIDTH
}
